import { IFormFieldDefaultProps } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import BasicFormField from 'components/foundation/form-fields/BasicFormField/BasicFormField';
import { AnyObject } from 'types/util/Object';
import EquipmentInspectionChecklistPicker, {
  IEquipmentInspectionChecklistPickerProps,
} from '../EquipmentInspectionChecklistPicker/EquipmentInspectionChecklistPicker';

export interface IEquipmentInspectionChecklistPickerFormFieldProps<FormType extends AnyObject>
  extends Omit<IEquipmentInspectionChecklistPickerProps, 'value' | 'onSelect'>,
    IFormFieldDefaultProps<string | null, FormType> {
  onSelect?: (value: string | null) => void;
}

const EquipmentInspectionChecklistPickerFormField = <FormType extends AnyObject>({
  form,
  name,
  validations,
  onSelect,
  className,
  revalidateOnNewValidations,
  ...other
}: IEquipmentInspectionChecklistPickerFormFieldProps<FormType>) => {
  const classes = classNames('equipment-inspection-checklist-picker-form-field', className);

  return (
    <BasicFormField
      name={name}
      form={form}
      onSelect={onSelect}
      className={classes}
      validations={validations}
      revalidateOnNewValidations={revalidateOnNewValidations}
    >
      {(value, onFormSelect) => <EquipmentInspectionChecklistPicker value={value} onSelect={onFormSelect} {...other} />}
    </BasicFormField>
  );
};

export default EquipmentInspectionChecklistPickerFormField;
